<template>
  <path
    d="M20 4.00018H4C2.9 4.00018 2.01 4.90018 2.01 6.00018L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00018C22 4.90018 21.1 4.00018 20 4.00018ZM4 9.00018H14.5V12.5002H4V9.00018ZM4 14.5002H14.5V18.0002H5C4.45 18.0002 4 17.5502 4 17.0002V14.5002ZM19 18.0002H16.5V9.00018H20V17.0002C20 17.5502 19.55 18.0002 19 18.0002Z"
  />
</template>
